import { useCallback, useEffect, useState } from "react";
import { listKeywords } from "@/lib/api";
import { DEFAULT_KEYWORD_COLOR } from "@/lib/palette";

// Loads `{ name: color, ... }` map (case-insensitive keys). Refresh on demand.
export function useKeywordColors() {
  const [map, setMap] = useState({});

  const refresh = useCallback(async () => {
    try {
      const items = await listKeywords();
      const m = {};
      for (const k of items) m[k.name.toLowerCase()] = k.color || DEFAULT_KEYWORD_COLOR;
      setMap(m);
    } catch {
      /* ignore */
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const colorOf = (name) => map[(name || "").toLowerCase()] || DEFAULT_KEYWORD_COLOR;

  return { map, colorOf, refresh };
}
